import { Templates, useTemplate } from "@/util-react/template";
import { LogisticAndDeliveryMobileBlackAndBlue } from "@/elements-react/logistic-and-delivery/templates/logistic.black-and-blue";

const templates: Record<Templates, React.ComponentType | null> = {
  [Templates.DEFAULT]: null,
  [Templates.BLACK_AND_BLUE]: LogisticAndDeliveryMobileBlackAndBlue,
};

export const LogisticAndDeliveryMobile = () => {
  const template = useTemplate();

  const TemplatedComponent = templates[template.template ?? Templates.DEFAULT];

  return TemplatedComponent ? <TemplatedComponent /> : null;
};
